<template>
    <div class="w-full flex items-start gap-x-5">
        <div class="rounded-lg min-w-[30%] bg-white p-10 text-black">
            <h2 class="text-2xl font-extralight underline">Remplir les champs suivants :</h2>
            <form @submit.prevent="saveForm" class="mt-8">
                <div class="w-full flex flex-col items-start ">
                    <label for="name" class="font-light" >Nom<span class="text-[#f44545]">*</span></label>
                    <input type="text" v-model="form.nom" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                </div>
                <div class="w-full flex flex-col pt-4 text-black">
                    <label for="debut" class="font-light" >Date d'entré<span class="text-[#f44545]">*</span></label>
                    <input type="date" v-model="form.startDate" placeholder="" name="debut" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                </div>
                    <button type="submit" :disabled="asSend" class="w-full mt-8 py-3 bg-[#5357ec] text-white rounded-md">
                        <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                        <span v-if="!asSend">Enregistrer</span>
                    </button>
            </form>
        </div>
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="mx-auto w-[89%] rounded-lg px-7 py-8 mt-10">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                <div class="flex justify-between">
                    <p class="mb-10 text-gray-700 text-2xl mt-10">N Ref number-Date/IUGB/PR/DAF/kmr</p>
                    <div>
                        <p class="mb-10 text-gray-700 text-2xl">Abidjan, le DATE</p>
                        <p class="mb-10 text-gray-700 text-2xl font-bold flex flex-col">
                            <span class="mb-10 ">A<br>
                                Monsieur le Directeur Général<br>
                                De la BANK name
                            </span>
                            <span class="font-normal underline">ABIDJAN</span>
                        </p>
                    </div>
                </div>
                <h2 class="text-2xl text-gray-700 mb-10"><span class="font-semibold underline">Objet</span>: Domiciliation de Salaire</h2>

                <div class="mb-10 text-gray-700 text-2xl">
                    <p class="mb-8 ml-20">
                            Monsieur le Directeur Général,
                    </p>
                    <p class="mb-10 text-justify">
                            Nous vous informons que <span class="font-bold">{{ form.nom ?? "TITLE NAME" }}</span> qui fait partie de notre personnel depuis le <span class="font-bold">{{ form.startDate ?? "DATE OF ENTRY" }}</span>, sous contrat à durée TYPE OF CONTRACT (DATE OF END OF CONTRACT IN CASE OF CDD) renouvelable (IN CASE OF CDD) et occupe actuellement les fonctions de POSITION vient de nous donner par écrit, en date du DATE OF REQUEST, l'ordre irrévocable d'avoir à verser à vos caisses, pour en créditer son compte BANK NAME numéro ACCOUNT NUMBER dans vos livres, toutes sommes pouvant lui être dues par notre Université, à quelque titre que ce soit, notamment son salaire net qui s'élève actuellement à <span class="font-bold"></span>NET SALARY FCFA.
                    </p>
                    <p class="mb-10">
                            Par la présente, nous nous engageons irrévocablement à exécuter ces instructions qui ne pourront être révoquées qu'avec votre accord exprès donné par écrit.
                    </p>
                    <p class="mb-10">
                            Enfin, nous nous engageons à vous aviser immédiatement de tout changement qui subviendrait dans la situation de <span class="font-bold">{{ form.nom ?? "TITLE NAME" }}</span> en particulier en cas de licenciement ou de saisie sur salaire. Dans cette éventualité, nous reconnaissons que nous serions tenus sous notre responsabilité de vous reverser l'intégralité des sommes dont nous pourrions être redevables envers l'intéressé à quelque titre que ce soit.
                    </p>
                    <p class="mb-16">Veuillez agréer, Monsieur le Directeur Général, nos salutations distinguées.</p>
                </div>

                <div class="text-right">
                    <p class="text-gray-700 mr-32 font-bold">SIGNATURE</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "DomiciliationSalaire",
    components: {Loader2},
    data() {
        return {
            asSend: false,
            form: {
                nom: null,
                startDate: null,
            }
        };
    },
    methods: {
        clearForm() {
            this.form.nom = null;
            this.form.startDate = null;
        },
        saveForm(){
            this.asSend = true;
            const data = {
                "content" : JSON.stringify(this.form),
                "doc_id":20,
                "user_id": localStorage.getItem("userId") ?? this.$store.getters.userId
            }
            API.post("user-docs", data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000)
                        this.clearForm();
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>